import { Link } from 'react-router-dom';
import Button from '../../../components/base/Button';

export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-car-line',
      title: 'Vehicle Registration & Renewal',
      description: 'Quick and efficient vehicle registration services for new and existing vehicles in Nevada.',
    },
    {
      icon: 'ri-file-text-line',
      title: 'Title Transfers & Tag Services',
      description: 'Complete title transfer services and license plate tag processing handled with precision.',
    },
    {
      icon: 'ri-search-eye-line',
      title: 'VIN Inspections',
      description: 'Professional VIN verification and inspection services for all vehicle types.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Smog Check Guidance',
      description: 'Expert guidance and assistance with smog check requirements and processes.',
    },
    {
      icon: 'ri-file-edit-line',
      title: 'Document Preparation',
      description: 'Professional document preparation and review services for all DMV needs.',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Customer Support',
      description: 'Dedicated customer support to guide you through every step of the process.',
    },
  ];

  const cities = ['Las Vegas', 'Henderson', 'North Las Vegas', 'Paradise', 'Sunrise Manor'];

  return (
    <section id="services" className="py-24 bg-gray-950">
      {/* Top gold line */}
      <div className="w-full h-px bg-gradient-to-r from-transparent via-amber-500/30 to-transparent mb-24 -mt-24"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-1.5 rounded-full bg-amber-500/10 border border-amber-500/25 mb-5">
            <i className="ri-service-line text-amber-400 mr-2 text-sm"></i>
            <span className="text-xs font-semibold text-amber-400 tracking-widest uppercase">What We Offer</span>
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4">
            Our{' '}
            <span className="bg-gradient-to-r from-amber-400 to-yellow-300 bg-clip-text text-transparent">
              Services
            </span>{' '}
            Overview
          </h2>
          <div className="flex items-center justify-center gap-3 mb-5">
            <div className="h-px w-12 bg-amber-500/50"></div>
            <i className="ri-star-fill text-amber-500 text-xs"></i>
            <div className="h-px w-12 bg-amber-500/50"></div>
          </div>
          <p className="text-lg text-gray-400 max-w-3xl mx-auto">
            Comprehensive DMV and document services provided through our trusted subsidiary brands
          </p>
        </div>

        {/* Service Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
          {services.map((service, index) => (
            <div
              key={index}
              className="group bg-gray-900 border border-gray-800 hover:border-amber-500/40 rounded-xl p-6 transition-all duration-300 hover:bg-gray-900/80"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-amber-500/10 border border-amber-500/20 rounded-lg mb-5 group-hover:bg-amber-500/20 group-hover:border-amber-500/40 transition-all duration-300">
                <i className={`${service.icon} text-2xl text-amber-400`}></i>
              </div>
              <h3 className="text-lg font-semibold text-white mb-3 group-hover:text-amber-300 transition-colors duration-300">
                {service.title}
              </h3>
              <p className="text-gray-400 text-sm leading-relaxed mb-4">
                {service.description}
              </p>
              <div className="flex items-center text-amber-500 text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <span>Learn more</span>
                <i className="ri-arrow-right-line ml-1"></i>
              </div>
            </div>
          ))}
        </div>

        {/* Service Area Banner */}
        <div className="relative rounded-2xl overflow-hidden border border-amber-500/20">
          <div className="absolute inset-0 bg-gradient-to-r from-amber-900/30 via-gray-900 to-amber-900/20"></div>
          <div className="absolute inset-0">
            <img
              src="https://public.readdy.ai/ai/img_res/1d92576b6af48dce56f7659d2bba0839.jpg"
              alt="Las Vegas service area"
              className="w-full h-full object-cover object-top opacity-15"
            />
          </div>
          <div className="relative z-10 p-10 text-center">
            <h3 className="text-2xl font-bold text-white mb-2">
              Serving the Greater{' '}
              <span className="text-amber-400">Las Vegas Area</span>
            </h3>
            <p className="text-gray-400 mb-8">
              We proudly assist customers throughout Clark County
            </p>
            <div className="flex flex-wrap justify-center gap-3 mb-8">
              {cities.map((city, index) => (
                <div
                  key={index}
                  className="flex items-center gap-2 px-4 py-2 bg-amber-500/10 border border-amber-500/25 rounded-full text-amber-300 text-sm font-medium"
                >
                  <i className="ri-map-pin-2-fill text-amber-400 text-xs"></i>
                  {city}
                </div>
              ))}
            </div>
            <Link to="/services">
              <Button variant="primary" size="md">
                <i className="ri-map-2-line mr-2"></i>
                View All Services
                <i className="ri-arrow-right-line ml-2"></i>
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
